import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Å½ivi!",
  "description": "",
  "published": "2007-08-07T00:00:00.000Z",
  "redirect_from": ["/blog/ivi/swizec/163"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`V nedeljo sem po dolgem Äasu, sploh veÄ ne vem kako dolgem, konÄno uspel popraviti svoje raÄunalo in blogal bi o tem prej, a sem in len in zaposlen, kar pa je za bloge najhujša kombinacija, saj kanijo malÄek trpeti.`}</p>
    <p>{`Po raÄunalnikovi smrti sem se odloÄil, da je problem v matiÄni plošÄi in zaÄel se je lov na tako, ki bi podpirala vso ostalo antiÄno opremo, ki prebiva v tisti škatli. Noro je, ampak praktiÄno ni trgovine, ki bi imela na zalogi kako matiÄno z AGP in IDE porti.`}</p>
    <p>{`Smešno, a resniÄno! Menda priÄakujejo, da bom z matiÄno vkup zamenjal vse od procesorja do rama in še diskov. Preklet steklen kapitalizem in Moorov zakon elektronike sta ušla preko vseh razumnih meja, vsaj za nas nebogate osebke. ÄŒe se na mojem raÄunalu še kdaj kaj polomi, mi ne preostane drugega, kot da ga zavrÅ¾en kot razbit kroÅ¾nik, ki ga nihÄe veÄ noÄe pogledati.`}</p>
    <p>{`Sedaj pa pika na i. Nekako mi je pri sestavljanju uspelo napajalnik vstaviti obrnjen na glavo in sedaj je 12cm ventilator obrnjen v steno namesto, da bi imel prostor dihati. Kako? Ne vem.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      